import { combineReducers } from 'redux';

import { noticeSendingReducer as noticeSending } from 'redpoints-front-notice-sending/NoticeSending';

const enforcement = combineReducers({
  noticeSending,
});

export default enforcement;
